import { render, staticRenderFns } from "./filterTag.vue?vue&type=template&id=7bafd84d&scoped=true"
import script from "./filterTag.vue?vue&type=script&lang=js"
export * from "./filterTag.vue?vue&type=script&lang=js"
import style0 from "./filterTag.vue?vue&type=style&index=0&id=7bafd84d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bafd84d",
  null
  
)

export default component.exports